import React, { useState } from 'react';
import { Switch, Tabs, Empty, Spin } from 'antd';
import type { EffectTemplate, TemplateCategory } from '../../../types/aiGenerate';
import { useTranslation } from '../../../hooks/useTranslation';
import './index.css';

interface EffectPanelProps {
  templates: EffectTemplate[];
  showCompare: boolean;
  onShowCompareChange: (show: boolean) => void;
  onApplyTemplate: (template: EffectTemplate) => void;
}

const TemplateCard: React.FC<{
  template: EffectTemplate;
  onApply: () => void;
}> = ({ template, onApply }) => {
  const { t } = useTranslation();
  return (
    <div className="template-card">
      <div className="template-card-image">
        <img src={template.coverImage} alt={template.name} />
      </div>
      <div className="template-card-content">
        <div className="template-card-name">{template.name}</div>
        <button className="template-apply-btn" onClick={onApply}>
          {t('aiGenerate.applyTemplate')}
        </button>
      </div>
    </div>
  );
};

const EffectPanel: React.FC<EffectPanelProps> = ({
  templates,
  showCompare,
  onShowCompareChange,
  onApplyTemplate,
}) => {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState<TemplateCategory>('scene');

  const filteredTemplates = templates.filter(
    (item) => item.category === activeCategory
  );

  const tabItems = [
    { key: 'scene', label: t('aiGenerate.sceneImage') },
    { key: 'model', label: t('aiGenerate.modelImage') },
  ];

  return (
    <div className="effect-panel">
      <div className="effect-panel-header">
        <span className="panel-title">{t('aiGenerate.playRecommend')}</span>
        <div className="compare-toggle">
          <span className="compare-label">{t('aiGenerate.compareImage')}</span>
          <Switch
            size="small"
            checked={showCompare}
            onChange={onShowCompareChange}
          />
        </div>
      </div>

      {/* 分类切换 */}
      <div className="effect-panel-tabs">
        <Tabs
          activeKey={activeCategory}
          onChange={(key) => setActiveCategory(key as TemplateCategory)}
          items={tabItems}
          size="small"
          centered
        />
      </div>

      {/* 模板列表 */}
      <div className="effect-panel-content">
        {templates.length === 0 ? (
          <div className="effect-panel-loading">
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={t('aiGenerate.noTemplates')}
            />
          </div>
        ) : filteredTemplates.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t('aiGenerate.noTemplatesInCategory')}
          />
        ) : (
          <div className="template-list">
            {filteredTemplates.map((template) => (
              <TemplateCard
                key={template.id}
                template={template}
                onApply={() => onApplyTemplate(template)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EffectPanel;
